<template>
  <div class="wrap">
    <Nav :title="$t('newAdd.rechargeRecordTitle')" fixed safeAreaInsetTop placeholder />
    <div class="tab-lists">
      <div class="tab-item" :class="[status === item.params.status ? 'on-tab-item' : '']"
        v-for="(item, index) in tabLists" :key="index" @click="handleTabItme(item.params.status)">
        {{ item.title }}
      </div>
    </div>
    <div class="content">
      <List url="/pay/record" :initParams="{ status: status }" ref="listRef">
        <template #item="{ item }">
          <div class="lists">
            <div class="list-item-order">{{ $t("newAdd.OrderNum") }}&nbsp;{{ item.payid }}</div>
            <div class="list-item">
              <div class="list-item-left">
                <div class="list-item-title">
                  <span class="list-item-title-text">{{ item.type }}</span>
                  <span v-if="item.status === '已完成'" class="list-item-title-sub">{{ `（${$t("newAdd.succeed")}）`
                  }}</span>
                  <span v-else class="list-item-title-sub-green">（{{
                    item.status === "待审核"
                      ? $t("newAdd.toAudit")
                      : $t("newAdd.rests")
                  }}）</span>
                </div>
                <span class="list-item-indate">{{ $format(item.indate) }}</span>
              </div>
              <div class="list-item-right">
                <div class="list-item-mbox">
                  <span class="list-item-money"> {{ item.money }}</span>
                  <span class="list-item-addMoney" v-if="item.status === '已完成' && item.money !== item.addMoney">({{
                    $t("newAdd.Arrive") }} {{ item.addMoney }})</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Navbar";
import List from "@/components/List";
import { cell, icon, field, Dialog, Toast } from "vant";
import { GET_RECHARGE_LISTS } from "@/api";
import { formatDate } from "@/utils/tools";
import verConfig from '../../utils/verConfig';
export default {
  components: {
    [cell.name]: cell,
    [icon.name]: icon,
    [field.name]: field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    List,
    Nav
  },
  data() {
    return {
      loading: false,
      finished: false,
      status: 0,
      alreadyLastPage: false,
      pages: 1,
      lists: [],
      tabLists: [
        {
          title: this.$t("newAdd.all"),
          params: { status: 0 },
        },
        {
          title: this.$t("newAdd.Completed"),
          params: { status: 1 },
        },
        {
          title: this.$t("newAdd.unfinished"),
          params: { status: 2 },
        },
      ],
      stateObj: {
        已汇款: "success",
        未通过: "not pass",
        汇款中: "processing",
        idpay: "Pay on behalf of",
      },
    };
  },

  mounted() { },

  methods: {
    onLoad() {
      this.getLists();
    },
    handleTabItme(status) {
      this.status = status;
      this.$nextTick(() => {
        this.$refs.listRef && this.$refs.listRef.handleRefresh();
      })
    },
    handleLoadMore() {
      if (!this.alreadyLastPage) {
        this.getLists();
      }
    },
    getLists() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      GET_RECHARGE_LISTS({
        status: this.status,
        page: this.pages,
      })
        .then((r) => {
          Toast.clear();
          this.loading = false;
          if (r.data.ret === 1) {
            Toast.clear();
            let dataLists = r.data.data.lists;
            if (r.data.data.currentPage > 1) {
              this.pages++;
              for (let i = 0; i < dataLists.length; i++) {
                this.lists.push(dataLists[i]);
              }
              if (r.data.data.currentPage === this.pages) {
                this.finished = true;
                this.loading = false;
              } else {
                this.finished = false;
                this.loading = true;
              }
            } else {
              Toast.clear();
              this.lists = dataLists;
              this.finished = true;
              this.loading = false;
            }

            this.alreadyLastPage = this.pages === 1 && dataLists.length === 0;
          } else {
            Toast.clear();
            this.$toast(r.data.msg);
            this.loading = false;
            this.finished = true;
          }
        })
        .catch((e) => {
          Toast.clear();
          this.loading = false;
          console.error(e);
        });
    },
    dateEvent(indate) {
      return formatDate("Y-m-d H:i:s", indate);
    },
    copy(item) {
      const copyText = `time: ${this.$format(item.indate)}\norder number: ${item.payid}\namount: ${item.money}`
      this.$copyText(copyText).then((e) => {
        Toast("Copy successfully");
      });
    }
  },
};
</script>

<style scoped lang="less">
@import url('../../assets/iconfonts/iconfont.css');
@background: var(--nav-background);
@color: var(--theme);

.wrap {
  flex: 1;
  width: 100%;
  min-height: 100vh;
  background-color: var(--newbg);

  .tab-lists {
    display: flex;
    align-items: center;
    background-color: var(--white);

    .tab-item {
      width: 33.33%;
      height: calc(40rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(14rem / 16);
      color: #6a6a6a
    }

    .on-tab-item {
      color: var(--bg)
    }
  }

  .content {
    padding: calc(20rem / 16);
  }
}


.lists {
  display: flex;
  flex-direction: column;
  // row-gap: calc(10rem / 16);
  // margin-bottom: calc(12rem / 16);
  background-color: var(--white);
  border-radius: calc(12rem / 16);
  padding: calc(12rem / 16);
}

.list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
}

.icon {
  color: var(--theme);
  position: absolute;
  right: 20px;
  bottom: 6px;
}

.list-item-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.list-item-order-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 6px;
}

.list-item-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.list-item-title-text {
  font-size: calc(23rem / 16);
  // color: #242424;
  color: var(--sizeColor);
}

.list-item-title-sub,
.list-item-title-sub-green {
  font-size: calc(12rem / 16);
  color: #1bb019;
}

.list-item-title-sub-green {
  color: @color;
}

.list-item-reason {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  color: #ff6e1c;
  width: calc(520rem / 16);
}

.list-item-bank {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  color: #888888;
}

.time {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 50%;
}

.amount {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 30%;
}


.list-item-indate {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  // color: #888888;
  color: var(--sizeColor);
  opacity: .6;
}

.list-item-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.list-item-order {
  font-size: calc(14rem / 16);
  color: var(--sizeColor);
}

.list-item-money {
  margin-top: calc(6rem / 16);
  font-size: calc(17rem / 16);
  color: @color;
}
</style>